import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database';

// Firebase configuration - reads from environment variables
// Configure these in your .env file:
// REACT_APP_FIREBASE_API_KEY=your_api_key
// REACT_APP_FIREBASE_AUTH_DOMAIN=your_project.firebaseapp.com
// REACT_APP_FIREBASE_PROJECT_ID=your_project_id
// REACT_APP_FIREBASE_STORAGE_BUCKET=your_project.appspot.com
// REACT_APP_FIREBASE_MESSAGING_SENDER_ID=your_sender_id
// REACT_APP_FIREBASE_APP_ID=your_app_id
// REACT_APP_FIREBASE_DATABASE_URL=https://your_project.firebaseio.com (optional)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL
};

// Initialize Firebase
let app;
let auth;
let db;
let storage;
let database;

try {
  // Initialize Firebase app
  app = initializeApp(firebaseConfig);

  // Initialize core Firebase services
  auth = getAuth(app);
  initializeFirestore(app, {
    experimentalForceLongPolling: true,
    useFetchStreams: false
  });
  db = getFirestore(app);
  storage = getStorage(app);

  console.log('Firebase initialized successfully');
} catch (error) {
  console.error('Firebase initialization error:', error);
  if (!app) {
    console.error('Failed to initialize Firebase app');
  }
}

// Realtime Database is optional — only initialize if a databaseURL is configured
try {
  if (firebaseConfig.databaseURL) {
    database = getDatabase(app);
  }
} catch (dbError) {
  console.warn('Realtime Database not available:', dbError?.message);
}

export { app, auth, db, storage, database };
export default app;
